export const safeLocalStorage = {
  setItem: (key, data) => {
    try {
      window.localStorage.setItem(key, data);
    } catch (error) {
      console.error(error);
    }
  },
  removeItem: (key) => {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  },
  getItem: (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      console.error(error);
    }
  },
  clear: () => {
    try {
      window.localStorage.clear();
    } catch (error) {
      console.error(error);
    }
  },
};
